import { FC } from 'react';

import { IconProps } from './types';

export const SolutionsIcon: FC<IconProps> = ({
	color = '#06519E',
	height = 24,
	size,
	width = 24,
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M10.863 13.998a1.046 1.046 0 0 1 1.478 0l3.66 3.66a1.05 1.05 0 0 1 0 1.484L12.34 22.8a1.06 1.06 0 0 1-.739.303c-.268 0-.535-.105-.74-.303l-3.658-3.66a1.05 1.05 0 0 1 0-1.484zm.74 2.217L9.42 18.4l2.181 2.185 2.18-2.185zM5.545 7.203l3.659 3.659a1.05 1.05 0 0 1 0 1.485l-3.66 3.659a1.06 1.06 0 0 1-.738.303c-.268 0-.536-.105-.74-.303L.41 12.346a1.05 1.05 0 0 1 0-1.484l3.659-3.659a1.046 1.046 0 0 1 1.478 0m13.59 0 3.66 3.659a1.05 1.05 0 0 1 0 1.485l-3.66 3.659a1.06 1.06 0 0 1-.739.303c-.267 0-.535-.105-.739-.303L14 12.346a1.05 1.05 0 0 1 0-1.484l3.66-3.659a1.046 1.046 0 0 1 1.477 0M4.806 9.419l-2.18 2.185 2.18 2.185 2.182-2.185zm13.591 0-2.18 2.185 2.18 2.185 2.181-2.185zM12.341.408l3.66 3.659a1.05 1.05 0 0 1 0 1.484l-3.66 3.66a1.06 1.06 0 0 1-.739.302c-.268 0-.535-.104-.74-.303L7.205 5.551a1.05 1.05 0 0 1 0-1.484l3.659-3.66a1.046 1.046 0 0 1 1.478 0m-.739 2.216-2.18 2.185 2.18 2.185 2.18-2.185z"
		/>
	</svg>
);
